import type {
	ShopDto,
	ShopReturnReasonsValuesDto,
} from "@babackapp/private-api-client/types";
import { getReasonFromId } from "./reason-from-id";

export function getReasonTextFromIdAndLang(
	reasonId: string,
	lang: string,
	shop: ShopDto,
) {
	const reason = getReasonFromId(reasonId, shop);

	if (reason) {
		return (
			reason.values.find((value: ShopReturnReasonsValuesDto) =>
				value.lang.includes(lang),
			)?.text || ""
		);
	}
}
